import React from "react"

export const WhiteOutlineText = ({ children, textStyle, viewStyle }) => {
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                ...viewStyle,
            }}
        >
            <p
                style={{
                    margin: 0,
                    WebkitTextStroke: "2px white",
                    paintOrder: "stroke fill",
                    ...textStyle,
                }}
            >
                {children}
            </p>
        </div>
    )
}